import { isFeatureEnabled } from 'owa-feature-flags';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { LocationPersonaControlViewState } from 'owa-location-persona';

export default function shouldRenderCity(location: LocationPersonaControlViewState): boolean {
    return (
        isFeatureEnabled('cal-mf-locationwellSearchByCity') &&
        location.postalAddress != null &&
        !isNullOrWhiteSpace(location.postalAddress.City)
    );
}
